"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9746],{

/***/ 1476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_Avatar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/constants/countryToFlagMap.ts
const countryToFlag = {
    AD: "\uD83C\uDDE6\uD83C\uDDE9",
    AR: "\uD83C\uDDE6\uD83C\uDDF7",
    AU: "\uD83C\uDDE6\uD83C\uDDFA",
    AT: "\uD83C\uDDE6\uD83C\uDDF9",
    BE: "\uD83C\uDDE7\uD83C\uDDEA",
    BO: "\uD83C\uDDE7\uD83C\uDDF4",
    BR: "\uD83C\uDDE7\uD83C\uDDF7",
    BG: "\uD83C\uDDE7\uD83C\uDDEC",
    CA: "\uD83C\uDDE8\uD83C\uDDE6",
    CL: "\uD83C\uDDE8\uD83C\uDDF1",
    CO: "\uD83C\uDDE8\uD83C\uDDF4",
    CR: "\uD83C\uDDE8\uD83C\uDDF7",
    HR: "\uD83C\uDDED\uD83C\uDDF7",
    CY: "\uD83C\uDDE8\uD83C\uDDFE",
    CZ: "\uD83C\uDDE8\uD83C\uDDFF",
    DK: "\uD83C\uDDE9\uD83C\uDDF0",
    DO: "\uD83C\uDDE9\uD83C\uDDF4",
    EC: "\uD83C\uDDEA\uD83C\uDDE8",
    EE: "\uD83C\uDDEA\uD83C\uDDEA",
    FI: "\uD83C\uDDEB\uD83C\uDDEE",
    FR: "\uD83C\uDDEB\uD83C\uDDF7",
    DE: "\uD83C\uDDE9\uD83C\uDDEA",
    GR: "\uD83C\uDDEC\uD83C\uDDF7",
    GT: "\uD83C\uDDEC\uD83C\uDDF9",
    HN: "\uD83C\uDDED\uD83C\uDDF3",
    HK: "\uD83C\uDDED\uD83C\uDDF0",
    HU: "\uD83C\uDDED\uD83C\uDDFA",
    IS: "\uD83C\uDDEE\uD83C\uDDF8",
    IE: "\uD83C\uDDEE\uD83C\uDDEA",
    IL: "\uD83C\uDDEE\uD83C\uDDF1",
    IT: "\uD83C\uDDEE\uD83C\uDDF9",
    JP: "\uD83C\uDDEF\uD83C\uDDF5",
    LV: "\uD83C\uDDF1\uD83C\uDDFB",
    LI: "\uD83C\uDDF1\uD83C\uDDEE",
    LT: "\uD83C\uDDF1\uD83C\uDDF9",
    LU: "\uD83C\uDDF1\uD83C\uDDFA",
    MT: "\uD83C\uDDF2\uD83C\uDDF9",
    MX: "\uD83C\uDDF2\uD83C\uDDFD",
    MC: "\uD83C\uDDF2\uD83C\uDDE8",
    NL: "\uD83C\uDDF3\uD83C\uDDF1",
    NZ: "\uD83C\uDDF3\uD83C\uDDFF",
    NI: "\uD83C\uDDF3\uD83C\uDDEE",
    NO: "\uD83C\uDDF3\uD83C\uDDF4",
    PA: "\uD83C\uDDF5\uD83C\uDDE6",
    PY: "\uD83C\uDDF5\uD83C\uDDFE",
    PE: "\uD83C\uDDF5\uD83C\uDDEA",
    PL: "\uD83C\uDDF5\uD83C\uDDF1",
    PT: "\uD83C\uDDF5\uD83C\uDDF9",
    PR: "\uD83C\uDDF5\uD83C\uDDF7",
    RO: "\uD83C\uDDF7\uD83C\uDDF4",
    RU: "\uD83C\uDDF7\uD83C\uDDFA",
    SM: "\uD83C\uDDF8\uD83C\uDDF2",
    RS: "\uD83C\uDDF7\uD83C\uDDF8",
    SK: "\uD83C\uDDF8\uD83C\uDDF0",
    SI: "\uD83C\uDDF8\uD83C\uDDEE",
    ES: "\uD83C\uDDEA\uD83C\uDDF8",
    SE: "\uD83C\uDDF8\uD83C\uDDEA",
    CH: "\uD83C\uDDE8\uD83C\uDDED",
    TW: "\uD83C\uDDF9\uD83C\uDDFC",
    TR: "\uD83C\uDDF9\uD83C\uDDF7",
    UA: "\uD83C\uDDFA\uD83C\uDDE6",
    GB: "\uD83C\uDDEC\uD83C\uDDE7",
    US: "\uD83C\uDDFA\uD83C\uDDF8",
    UY: "\uD83C\uDDFA\uD83C\uDDFE"
};

// EXTERNAL MODULE: ./src/utils/uploadUtils.ts
var uploadUtils = __webpack_require__(80831);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/atoms/Avatar/index.tsx






const defaultClassName = "inline-flex items-center justify-center rounded-full bg-gray-500";
const variantSize = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-10 w-10",
    xl: "h-12 w-12",
    "2xl": "h-14 w-14"
};
const variantText = {
    sm: "text-xs",
    md: "text-sm",
    lg: "",
    xl: "text-lg",
    "2xl": "text-xl"
};
const variantImgSize = {
    sm: {
        w: 24,
        h: 24
    },
    md: {
        w: 32,
        h: 32
    },
    lg: {
        w: 40,
        h: 40
    },
    xl: {
        w: 48,
        h: 48
    },
    "2xl": {
        w: 56,
        h: 56
    }
};
const Avatar = (param)=>{
    let { size , user  } = param;
    const classes = (0,clsx_m/* default */.Z)(defaultClassName, variantSize[size]);
    const classesText = (0,clsx_m/* default */.Z)(variantText[size], "font-medium leading-none text-white");
    const imgSize = variantImgSize[size];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "group block flex-shrink-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes,
                children: user.profilePhoto ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative inline-block",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: classes,
                            src: (0,uploadUtils/* getUploadUrl */.M)(user.profilePhoto),
                            alt: user.firstName,
                            width: imgSize.w,
                            height: imgSize.h
                        }),
                        user.shareLocation && user.countryCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute -bottom-2 -right-2 block text-xl",
                            children: countryToFlag[user.countryCode]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classesText,
                    children: user.firstName[0].toUpperCase()
                })
            })
        })
    });
};
Avatar.displayName = "Avatar";
/* harmony default export */ var atoms_Avatar = (Avatar);


/***/ }),

/***/ 58605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);


const Container = (param)=>{
    let { className , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8", className),
        ...props
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 37389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

var _heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_1___namespace_cache;
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(801);


const DynamicHeroIcon = (props)=>{
    const { ...icons } = /*#__PURE__*/ (_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_1___namespace_cache || (_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_1___namespace_cache = __webpack_require__.t(_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_1__, 2)));
    // @ts-ignore
    const TheIcon = icons[props.icon];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TheIcon, {
            className: props.className,
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DynamicHeroIcon);


/***/ }),

/***/ 6334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; }
/* harmony export */ });
/* unused harmony export Logomark */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


const LOGO_FACTOR = 1.25;
const Logomark = (props)=>{
    return /*#__PURE__*/ _jsx("svg", {
        viewBox: "0 0 40 40",
        "aria-hidden": "true",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20ZM4 20c0 7.264 5.163 13.321 12.02 14.704C17.642 35.03 19 33.657 19 32V8c0-1.657-1.357-3.031-2.98-2.704C9.162 6.68 4 12.736 4 20Z"
        })
    });
};
const Logo = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: "/assets/images/svgs/logo-dark.svg",
        alt: "Codealo Logo Default",
        className: "",
        width: 110 * LOGO_FACTOR,
        height: 16 * LOGO_FACTOR
    });
};


/***/ }),

/***/ 35604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Example; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _constants_links__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28242);
/* harmony import */ var _constants_navigation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10652);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_atoms_Logo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6334);





const navigation = {
    support: [
        {
            name: "Email",
            href: "mailto:apoyo@codealo.dev"
        },
        {
            name: "Feedback Telegram",
            href: _constants_links__WEBPACK_IMPORTED_MODULE_4__/* .FEEDBACK_TELEGRAM_LINK */ .N
        }
    ],
    company: [
        {
            name: "About",
            href: "#"
        }
    ],
    legal: [
        {
            name: "Pol\xedtica de Privacidad",
            href: "/politica-de-privacidad"
        },
        {
            name: "T\xe9rminos y Condiciones",
            href: "/terminos-y-condiciones"
        }
    ],
    social: [
        {
            name: "Facebook",
            href: "https://www.facebook.com/codealo",
            icon: (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    ...props,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
                        clipRule: "evenodd"
                    })
                })
        },
        {
            name: "Instagram",
            href: "https://www.instagram.com/codealo",
            icon: (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    ...props,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z",
                        clipRule: "evenodd"
                    })
                })
        },
        {
            name: "Twitter",
            href: "https://www.twitter.com/codealodev",
            icon: (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    ...props,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
                    })
                })
        },
        // {
        //   name: "GitHub",
        //   href: "#",
        //   icon: (props: any) => (
        //     <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
        //       <path
        //         fillRule="evenodd"
        //         d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
        //         clipRule="evenodd"
        //       />
        //     </svg>
        //   ),
        // },
        {
            name: "YouTube",
            href: "https://www.youtube.com/@CodealoDev",
            icon: (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    fill: "currentColor",
                    viewBox: "0 0 24 24",
                    ...props,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z",
                        clipRule: "evenodd"
                    })
                })
        }
    ]
};
function Example() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        className: "bg-white",
        "aria-labelledby": "footer-heading",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                id: "footer-heading",
                className: "sr-only",
                children: "Footer"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "xl:grid xl:grid-cols-3 xl:gap-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "space-y-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_atoms_Logo__WEBPACK_IMPORTED_MODULE_3__/* .Logo */ .T, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-sm leading-6 text-gray-600",
                                        children: "Aprende a programar desde cero y convi\xe9rtete en un desarrollador junto a la mejor comunidad de habla hispana."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex space-x-6",
                                        children: navigation.social.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                href: item.href,
                                                className: "text-gray-400 hover:text-gray-500",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "sr-only",
                                                        children: item.name
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.icon, {
                                                        className: "h-6 w-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            }, item.name))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "md:grid md:grid-cols-2 md:gap-8",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "text-sm font-semibold leading-6 text-gray-900",
                                                        children: "Recursos"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                        role: "list",
                                                        className: "mt-6 space-y-4",
                                                        children: _constants_navigation__WEBPACK_IMPORTED_MODULE_1__/* .NAV_LINKS.map */ .q.map((param)=>/*#__PURE__*/ {
                                                            let { label , href  } = param;
                                                            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                    href: href,
                                                                    className: "text-sm leading-6 text-gray-600 hover:text-gray-900",
                                                                    prefetch: false,
                                                                    children: label
                                                                })
                                                            }, label);
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "mt-10 md:mt-0",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "text-sm font-semibold leading-6 text-gray-900",
                                                        children: "Apoyo"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                        role: "list",
                                                        className: "mt-6 space-y-4",
                                                        children: navigation.support.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                    href: item.href,
                                                                    className: "text-sm leading-6 text-gray-600 hover:text-gray-900",
                                                                    prefetch: false,
                                                                    target: "_blank",
                                                                    rel: "nofollow",
                                                                    children: item.name
                                                                })
                                                            }, item.name))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "md:grid md:grid-cols-2 md:gap-8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "md:mt-0",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "text-sm font-semibold leading-6 text-gray-900",
                                                    children: "Legal"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    role: "list",
                                                    className: "mt-6 space-y-4",
                                                    children: navigation.legal.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                href: item.href,
                                                                className: "text-sm leading-6 text-gray-600 hover:text-gray-900",
                                                                prefetch: false,
                                                                children: item.name
                                                            })
                                                        }, item.name))
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-16 border-t border-gray-900/10 pt-8 sm:mt-20 lg:mt-24",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs leading-5 text-gray-500",
                            children: "\xa9 2023 Codealo. Todos los derechos reservados."
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 58620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ organisms_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(65820);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 181 modules
var motion = __webpack_require__(13454);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/atoms/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(1476);
// EXTERNAL MODULE: ./src/components/atoms/Container/index.tsx
var Container = __webpack_require__(58605);
// EXTERNAL MODULE: ./src/components/atoms/DynamicHeroIcon/index.tsx
var DynamicHeroIcon = __webpack_require__(37389);
// EXTERNAL MODULE: ./src/constants/navigation.ts
var navigation = __webpack_require__(10652);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js + 3 modules
var menu = __webpack_require__(17158);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(44080);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(86493);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/contexts/AuthContext.tsx
var AuthContext = __webpack_require__(96348);
;// CONCATENATED MODULE: ./src/components/atoms/HeaderProfileDropdown/index.tsx










const HeaderProfileDropdown = ()=>{
    const { user , logout  } = (0,AuthContext/* useAuth */.a)();
    // Logout on button click
    const onLogout = (e)=>{
        e.preventDefault();
        logout();
    };
    if (!user) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu */.v, {
            as: "div",
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu.Button */.v.Button, {
                    className: "-m-1.5 flex items-center p-1.5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Open user menu"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            user: user,
                            size: "md"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "hidden lg:flex lg:items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-4 text-sm font-semibold leading-6 text-gray-900",
                                    "aria-hidden": "true",
                                    children: user.firstName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon, {
                                    className: "ml-2 h-5 w-5 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    as: react.Fragment,
                    enter: "transition ease-out duration-100",
                    enterFrom: "transform opacity-0 scale-95",
                    enterTo: "transform opacity-100 scale-100",
                    leave: "transition ease-in duration-75",
                    leaveFrom: "transform opacity-100 scale-100",
                    leaveTo: "transform opacity-0 scale-95",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Items */.v.Items, {
                        className: "absolute right-0 z-10 mt-2.5 w-auto min-w-[180px] origin-top-right divide-y rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none",
                        children: navigation/* USER_NAVIGATION.map */.k.map((param)=>/*#__PURE__*/ {
                            let { name , action , href , icon  } = param;
                            return (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                    children: (param)=>{
                                        let { active  } = param;
                                        if (href) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                href: href(user),
                                                className: classnames_default()(active ? "bg-gray-100 text-gray-900" : "text-gray-700", "group flex items-center px-4 py-2 text-sm"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicHeroIcon/* default */.Z, {
                                                        icon: icon,
                                                        className: "mr-3 h-5 w-5 text-primary group-hover:text-gray-500",
                                                        "aria-hidden": "true"
                                                    }),
                                                    name
                                                ]
                                            });
                                        } else if (action) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: classnames_default()(active ? "bg-gray-100 text-gray-900" : "text-gray-700", "group flex w-full items-center px-4 py-2 text-sm"),
                                                onClick: onLogout,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicHeroIcon/* default */.Z, {
                                                        icon: icon,
                                                        className: "mr-3 h-5 w-5 text-primary group-hover:text-gray-500",
                                                        "aria-hidden": "true"
                                                    }),
                                                    name
                                                ]
                                            });
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                    }
                                })
                            }, name);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var atoms_HeaderProfileDropdown = (HeaderProfileDropdown);

// EXTERNAL MODULE: ./src/components/atoms/Logo/index.tsx
var Logo = __webpack_require__(6334);
;// CONCATENATED MODULE: ./src/components/molecules/NavLinks/index.tsx





const NavLinks = ()=>{
    let [hoveredIndex, setHoveredIndex] = (0,react.useState)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: navigation/* NAV_LINKS.map */.q.map((param, index)=>/*#__PURE__*/ {
            let { label , href  } = param;
            return (0,jsx_runtime.jsxs)((link_default()), {
                href: href,
                className: "relative -mx-3 -my-2 rounded-lg px-3 py-2 text-sm text-gray-700 transition-colors delay-150 hover:text-gray-900 hover:delay-[0ms]",
                onMouseEnter: ()=>setHoveredIndex(index),
                onMouseLeave: ()=>setHoveredIndex(null),
                prefetch: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        children: hoveredIndex === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                            className: "absolute inset-0 rounded-lg bg-gray-100",
                            layoutId: "hoverBackground",
                            initial: {
                                opacity: 0
                            },
                            animate: {
                                opacity: 1,
                                transition: {
                                    duration: 0.15
                                }
                            },
                            exit: {
                                opacity: 0,
                                transition: {
                                    duration: 0.15,
                                    delay: 0.2
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "relative z-10",
                        children: label
                    })
                ]
            }, label);
        })
    });
};
/* harmony default export */ var molecules_NavLinks = (NavLinks);

;// CONCATENATED MODULE: ./src/components/organisms/Header/index.tsx











function MenuIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5 6h14M5 18h14M5 12h14",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
function ChevronUpIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M17 14l-5-5-5 5",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
function MobileNavLink(param) {
    let { children , icon , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
        as: (link_default()),
        className: " flex flex-row items-center text-base leading-7 tracking-tight text-gray-700",
        ...props,
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicHeroIcon/* default */.Z, {
                icon: icon,
                className: "mr-3 h-5 w-5 text-primary group-hover:text-gray-500",
                "aria-hidden": "true"
            }),
            children
        ]
    });
}
const Header = ()=>{
    const { user , logout  } = (0,AuthContext/* useAuth */.a)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: "sticky top-0 z-50 bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                className: "relative z-20 flex w-full justify-between py-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-20 flex items-center gap-16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                "aria-label": "Home",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* Logo */.T, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex gap-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden lg:flex lg:gap-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_NavLinks, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden lg:flex lg:flex-1 lg:justify-end",
                        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_HeaderProfileDropdown, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/login",
                            className: "relative -mx-3 -my-2 rounded-lg bg-dark px-3 py-2 text-sm text-white transition-colors delay-150 hover:text-gray-200 hover:delay-[0ms]",
                            prefetch: false,
                            children: "Login"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-4 flex items-center justify-end gap-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
                            className: "lg:hidden",
                            children: (param)=>/*#__PURE__*/ {
                                let { open  } = param;
                                return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                            className: "relative z-10 -m-2 inline-flex items-center rounded-lg stroke-gray-900 p-2 hover:bg-gray-200/50 hover:stroke-gray-600 active:stroke-gray-900 [&:not(:focus-visible)]:focus:outline-none",
                                            "aria-label": "Toggle site navigation",
                                            children: (param)=>{
                                                let { open  } = param;
                                                return open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUpIcon, {
                                                    className: "h-6 w-6"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon, {
                                                    className: "h-6 w-6"
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                            initial: false,
                                            children: open && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Overlay */.J.Overlay, {
                                                        static: true,
                                                        as: motion/* motion.div */.E.div,
                                                        initial: {
                                                            opacity: 0
                                                        },
                                                        animate: {
                                                            opacity: 1
                                                        },
                                                        exit: {
                                                            opacity: 0
                                                        },
                                                        className: "fixed inset-0 z-0 bg-gray-300/60 backdrop-blur"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                                                        static: true,
                                                        as: motion/* motion.div */.E.div,
                                                        initial: {
                                                            opacity: 0,
                                                            y: -32
                                                        },
                                                        animate: {
                                                            opacity: 1,
                                                            y: 0
                                                        },
                                                        exit: {
                                                            opacity: 0,
                                                            y: -32,
                                                            transition: {
                                                                duration: 0.2
                                                            }
                                                        },
                                                        className: "absolute inset-x-0 top-0 z-0 origin-top rounded-b-2xl bg-gray-50 px-6 pb-6 pt-32 shadow-2xl shadow-gray-900/20",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "space-y-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavLink, {
                                                                    icon: "BookOpenIcon",
                                                                    href: "/cursos",
                                                                    children: "Cursos"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavLink, {
                                                                    icon: "BookOpenIcon",
                                                                    href: "/ejercicios",
                                                                    children: "Ejercicios"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavLink, {
                                                                    icon: "PencilSquareIcon",
                                                                    href: "/blog",
                                                                    children: "Blog"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                                                user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavLink, {
                                                                            href: "/perfiles/".concat(user.profileUrl),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "flex flex-row space-x-4",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                                                        user: user,
                                                                                        size: "lg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        children: [
                                                                                            user.firstName,
                                                                                            " ",
                                                                                            user.lastName
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavLink, {
                                                                            icon: "Cog8ToothIcon",
                                                                            href: "/configuraciones",
                                                                            children: "Configuraciones"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                                            as: "button",
                                                                            className: " flex flex-row items-center text-base leading-7 tracking-tight text-gray-700",
                                                                            onClick: (e)=>logout(),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicHeroIcon/* default */.Z, {
                                                                                    icon: "ArrowRightOnRectangleIcon",
                                                                                    className: "mr-3 h-5 w-5 text-primary group-hover:text-gray-500",
                                                                                    "aria-hidden": "true"
                                                                                }),
                                                                                "Cerrar Sesi\xf3n"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavLink, {
                                                                    href: "/login",
                                                                    icon: "ArrowRightOnRectangleIcon",
                                                                    children: "Login"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var organisms_Header = (Header);


/***/ }),

/***/ 28242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CODERHOUSE_LINK; },
/* harmony export */   "N": function() { return /* binding */ FEEDBACK_TELEGRAM_LINK; }
/* harmony export */ });
const FEEDBACK_TELEGRAM_LINK = "https://t.me/+78EC_YKwcH01MGJh";
const CODERHOUSE_LINK = "https://www.coderhouse.com/?utm_source=codealo&utm_medium=alianzas&utm_campaign=plataforma";


/***/ }),

/***/ 10652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ USER_NAVIGATION; },
/* harmony export */   "q": function() { return /* binding */ NAV_LINKS; }
/* harmony export */ });
const NAV_LINKS = [
    {
        label: "Cursos",
        href: "/cursos"
    },
    {
        label: "Blog",
        href: "/blog"
    },
    {
        label: "Ejercicios",
        href: "/ejercicios"
    }
];
const USER_NAVIGATION = [
    {
        name: "Perfil",
        icon: "UserIcon",
        href: (user)=>"/perfiles/".concat(user.profileUrl),
        action: null
    },
    {
        name: "Configuraciones",
        icon: "Cog8ToothIcon",
        href: ()=>"/configuraciones"
    },
    {
        name: "Cerrar Sesi\xf3n",
        icon: "ArrowRightOnRectangleIcon",
        href: null,
        action: "logout"
    }
];


/***/ }),

/***/ 80831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getUploadUrl; }
/* harmony export */ });
const getUploadUrl = (media)=>{
    if (media.url.includes("http")) {
        return media.url;
    } else {
        // remove first slash from medial url\
        const url = media.url.replace(/^\//, "");
        return "".concat("https://codealo-v2-dev-cms.onrender.com/", "/").concat(url);
    }
};


/***/ })

}]);